
import { Component, Input } from '@angular/core';

import { InfluencerPost } from '../../../../../../models/influencer';
import { Router } from '@angular/router';
import { platformIconPathById } from '../../../../../app.constants';
import { DateUtils } from '../../../../../utils/date.utils';
import { UserService } from '../../../../../services/user.service';

@Component({
    selector: 'latest-post-item',
    templateUrl: './latest-post-item.component.html',
    styleUrls: ['./latest-post-item.component.scss']
})
export class LatestPostItemComponent {
    @Input() post: InfluencerPost = new InfluencerPost();
    @Input() index: number;
    @Input() isLastItem: boolean;
    @Input() printMode: boolean;

    constructor(private router: Router, private userService: UserService) { }

    getPlatformIcon(platform): string {
        if (!platform) {
            return '';
        }
        return platformIconPathById[platform.id] && platformIconPathById[platform.id].path;
    }

    formatPublishDate(publishDateTimestamp: number): string {
        const publishDate = new Date(publishDateTimestamp);
        return DateUtils.formatDate(publishDate.toString());
    }

    openPostPage() {
        const currentInfluencer = this.userService.getInfluencerInfo();
        // Todo: consider Influencer page navigation
        // influencer platform version
        if (currentInfluencer) {
            return this.router.navigate(['dashboard', 'post', this.post.urlHash]);
        } else {
            return this.router.navigate(['post'], {
                queryParams: {
                    influencerId: this.post.blog_id,
                    urlHash: this.post.urlHash,
                    activeAccount: this.userService.getCompanyId()
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/latest-posts/latest-post-item/latest-post-item.component.ts